import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
var CLEditorService = /** @class */ (function () {
    function CLEditorService() {
        this._subject = new Subject();
    }
    CLEditorService.prototype.refresh = function (timeout) {
        if (timeout === void 0) { timeout = 0; }
        this._subject.next(timeout);
    };
    Object.defineProperty(CLEditorService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    CLEditorService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CLEditorService.ctorParameters = function () { return []; };
    return CLEditorService;
}());
export { CLEditorService };
//# sourceMappingURL=cleditor.service.js.map